import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ManufacturerPreferences } from '@/areas/settings/part-intelligence/OrganizationSettings/ManufacturerPreferences';
import { canViewDesignSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/manufacturer-preferences')({
    staticData: {
        access: { permissions: canViewDesignSettings },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ManufacturerPreferences />;
}
